import React from "react";

//Import withRouter
import withRouter from "../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";

const FilterBar = (props: any) => {
  return (
    <React.Fragment>
    </React.Fragment>
  );
};

export default withTranslation()(withRouter(FilterBar));
